<template>
  <div class="audit-dialog" v-if="visible" @click.self="closeDialog">
    <div class="dialog-content">
      <!-- 商品信息部分 -->
      <div class="product-section">
        <h3 class="section-title">询盘商品信息</h3>

        <div class="product-header">
          <img :src="$baseUrl + product.image" class="product-image" alt="商品图片">
          <div class="product-info">
            <div class="product-name">{{ product.commodityName }}</div>
            <div class="product-category">{{ product.categoryName }}</div>
          </div>
        </div>

        <div class="product-details">
          <div class="detail-row">
            <span class="label">规格：</span>
            <span>{{ product.specifications }}</span>
          </div>
          <div class="detail-row">
            <span class="label">购买数量：</span>
            <span>{{ product.quantity }}</span>
            <span class="label price-label">现价：</span>
            <span>{{ product.presentPrice }}</span>
          </div>
          <div class="detail-row">
            <span class="label">消费者收件邮箱：</span>
            <span>{{ product.email }}</span>
          </div>
          <div class="detail-row">
            <span class="label">备注：</span>
            <span class="remark">{{ product.message }}</span>
          </div>
          <div class="detail-row">
            <span class="label">审核状态：</span>
            <span>{{
              product.status == 0
              ? "审核中"
              : product.status == 1
              ? "通过"
              : "未通过"
              }}</span>
          </div>
        </div>
      </div>

      <!-- 确认信息部分 -->
      <div class="confirm-section">
        <h3 class="section-title">确认信息</h3>

        <div class="form-group">
          <label>审核状态：</label>
          <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%;" @change="handleStatusChange">
            <el-option v-for="(item, index) in exmineStatus" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>

        <template v-if="form.status === 1">
          <div class="form-group">
            <label>商品名称：</label>
            <input type="textarea" v-model="form.commodityName" class="form-input">
          </div>

          <div class="form-group">
            <label>商品规格：</label>
            <input type="text" v-model="form.specifications" class="form-input">
          </div>

          <div class="form-group">
            <label>价格：</label>
            <input type="number" v-model="form.unitPrice" class="form-input">
          </div>

          <div class="form-group">
            <label>购买数量：</label>
            <input type="number" v-model="form.quantity" class="form-input">
          </div>

          <div class="form-group">
            <label>总价：</label>
            <input type="number" v-model="form.totalPrice" class="form-input">
          </div>

          <div class="form-group">
            <label>收件人邮箱：</label>
            <input type="email" v-model="form.toUser" class="form-input">
          </div>

          <div class="form-group">
            <label>回件商家邮箱：</label>
            <input type="email" v-model="form.businessEmail" class="form-input">
          </div>

          <!-- 收款信息部分 -->
          <div class="payment-section">
            <h3 class="section-title">收款信息</h3>

            <div class="payment-methods">
              <button class="method-btn" :class="{ active: form.collectionType === 1 }"
                @click="form.collectionType = 1">
                收款码
              </button>
              <button class="method-btn" :class="{ active: form.collectionType === 2 }"
                @click="form.collectionType = 2">
                银行卡
              </button>
            </div>

            <div v-if="form.collectionType === 1" class="qrcode-section">
              <div class="upload-area">
                <el-upload :action="$baseUrl + '/other/upload'" :before-upload="handleBeforeUpload"
                  list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                  :on-exceed="hadleExceed" :on-success="handelSuccess" :limit="1" name="file" :file-list="fileList"
                  :class="{ 'hide-upload': fileList.length >= 1 }">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div>

            <div v-else class="bank-section">
              <div class="form-group">
                <label>受益人姓名：</label>
                <input type="text" v-model="form.beneficiaryName" placeholder="请输入受益人姓名" class="form-input">
              </div>
              <div class="form-group">
                <label>受益人地址：</label>
                <input type="text" v-model="form.beneficiaryAddress" placeholder="请输入受益人地址" class="form-input">
              </div>
              <div class="form-group">
                <label>受益人账号：</label>
                <input type="text" v-model="form.beneficiaryAccNo" placeholder="请输入受益人账号" class="form-input">
              </div>
              <div class="form-group">
                <label>银行地址：</label>
                <input type="text" v-model="form.addressOfBank" placeholder="请输入银行地址" class="form-input">
              </div>
              <div class="form-group">
                <label>SWIFT码：</label>
                <input type="text" v-model="form.swiftCode" placeholder="请输入SWIFT码" class="form-input">
              </div>
              <div class="form-group">
                <label>邮政编码：</label>
                <input type="text" v-model="form.postCode" placeholder="请输入邮政编码" class="form-input">
              </div>
              <div class="form-group">
                <label>受益人银行：</label>
                <input type="text" v-model="form.beneficiaryBank" placeholder="请输入受益人银行" class="form-input">
              </div>
              <div class="form-group">
                <label>电话：</label>
                <input type="tel" v-model="form.tel" placeholder="请输入电话" class="form-input">
              </div>
              <div class="form-group">
                <label>自定义字段：</label>
                <Editor style="height: 500px; overflow-y: hidden" v-model="form.customDefinition"
                  :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />
              </div>
            </div>
          </div>

        </template>
      </div>

      <!-- 操作按钮 -->
      <div class="action-buttons">
        <button class="cancel-btn" @click="closeDialog">取消</button>
        <button class="confirm-btn" @click="confirmAudit">确认审核</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { lazyWangeditor } from "@/utils/lazy-editor";
  export default {
    name: 'AuditDialog',
    components: {
      // @wangeditor 在 Node 中 import 即抛 Element is not defined,
      // 用共享工厂:客户端懒加载真组件,服务端渲染空占位
      Editor: lazyWangeditor("Editor"),
      Toolbar: lazyWangeditor("Toolbar"),
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      product: {
        type: Object,
        default: () => ({
          id: 0,
          image: '',
          name: '',
          category: '',
          specification: '',
          quantity: 0,
          price: 0,
          email: '',
          remark: '',
          status: '待审核'
        })
      }
    },
    data() {
      return {
        editor: null,
        editorConfig: {
          placeholder: "请输入内容...",
          MENU_CONF: {
            uploadImage: {
              customUpload: this.uploadImg,
            },
          },
        },
        mode: "default",
        fileList: [],
        exmineStatus: [
          { value: 1, label: "通过" },
          { value: 2, label: "未通过" }
        ],
        paymentMethod: 'qrcode',
        form: {
          id: null,
          commodityName: '',
          specifications: '',
          unitPrice: 0,
          quantity: 0,
          totalPrice: 0,
          toUser: '',
          businessEmail: '',
          status: null,
          collectionQrcode: '',
          beneficiaryName: '',
          beneficiaryAddress: '',
          beneficiaryAccNo: '',
          addressOfBank: '',
          swiftCode: '',
          postCode: '',
          beneficiaryBank: '',
          tel: '',
          customDefinition: '',
          collectionType: 1,
        }
      }
    },
    watch: {
      'form.quantity'(newVal) {
        this.calculateTotalPrice();
      },
      'form.unitPrice'(newVal) {  // 修正为unitPrice
        this.calculateTotalPrice();
      },
      'form.collectionType'(newVal) {
        this.resetPaymentForm(newVal);
      }
    },
    methods: {
      onCreated(editor) {
        this.editor = Object.seal(editor);
      },
      handleStatusChange(val) {
        if (val == 1) {
          // 审核通过时，初始化表单数据
          this.form = {
            ...this.form,
            id: this.product.id,
            commodityName: this.product.commodityName,
            specifications: this.product.specifications,
            unitPrice: this.product.presentPrice,
            quantity: this.product.quantity,
            totalPrice: this.product.presentPrice * this.product.quantity,
            toUser: this.product.email,
            businessEmail: '',
            status: val,
            collectionType: this.form.collectionType, // 保留当前支付方式
            // 保留收款相关字段
            collectionQrcode: this.form.collectionQrcode,
            beneficiaryName: this.form.beneficiaryName,
            beneficiaryAddress: this.form.beneficiaryAddress,
            beneficiaryAccNo: this.form.beneficiaryAccNo,
            addressOfBank: this.form.addressOfBank,
            swiftCode: this.form.swiftCode,
            postCode: this.form.postCode,
            beneficiaryBank: this.form.beneficiaryBank,
            tel: this.form.tel,
            customDefinition: this.form.customDefinition
          };
        } else {
          // 审核不通过时，重置所有字段
          this.form = {
            id: this.product.id,
            commodityName: '',
            specifications: '',
            unitPrice: 0,
            quantity: 0,
            totalPrice: 0,
            toUser: '',
            businessEmail: '',
            status: val,
            collectionQrcode: '',
            beneficiaryName: '',
            beneficiaryAddress: '',
            beneficiaryAccNo: '',
            addressOfBank: '',
            swiftCode: '',
            postCode: '',
            beneficiaryBank: '',
            tel: '',
            customDefinition: '',
            collectionType: 1 // 重置为收款码
          };
          // 同时清空上传的文件列表
          this.fileList = [];
        }
      },
      closeDialog() {
        this.resetForm();
        this.$emit('update:visible', false);
      },
      // 新增方法：重置表单内容
      resetForm() {
        this.form = {
          id: this.product.id,
          commodityName: this.product.commodityName,
          specifications: this.product.specifications,
          unitPrice: this.product.presentPrice,
          quantity: this.product.quantity,
          totalPrice: this.product.presentPrice * this.product.quantity,
          toUser: this.product.email,
          businessEmail: '',
          status: null,
          collectionQrcode: '',
          beneficiaryName: '',
          beneficiaryAddress: '',
          beneficiaryAccNo: '',
          addressOfBank: '',
          swiftCode: '',
          postCode: '',
          beneficiaryBank: '',
          tel: '',
          customDefinition: '',
          collectionType: 1, // 默认选择收款码
        };
        this.fileList = [];

        // 如果有已存在的收款码，恢复初始状态
        if (this.product.collectionQrcode) {
          this.form.collectionQrcode = this.$baseUrl + this.product.collectionQrcode;
          this.fileList = [{
            name: '收款码',
            url: this.form.collectionQrcode
          }];
        }
      },
      calculateTotalPrice() {
        this.form.totalPrice = this.form.unitPrice * this.form.quantity;
      },
      resetPaymentForm(type) {
        if (type === 1) {
          // 重置银行卡信息
          this.form = {
            ...this.form,
            beneficiaryName: '',
            beneficiaryAddress: '',
            beneficiaryAccNo: '',
            addressOfBank: '',
            swiftCode: '',
            postCode: '',
            beneficiaryBank: '',
            tel: '',
            customDefinition: ''
          };
        } else {
          // 重置收款码信息
          this.form.collectionQrcode = '';
          this.fileList = [];
        }
      },
      confirmAudit() {
        // 非空验证逻辑
        if (this.form.status === 1) {
          if (!this.form.commodityName || this.form.commodityName.trim() === "") {
            this.$message.error("商品名称不能为空");
            return;
          }
          if (!this.form.specifications || this.form.specifications.trim() === "") {
            this.$message.error("商品规格不能为空");
            return;
          }
          if (!this.form.unitPrice || Number(this.form.unitPrice) <= 0) {
            this.$message.error("商品单价不能小于1");
            return;
          }
          if (!this.form.quantity || Number(this.form.quantity) <= 0) {
            this.$message.error("购买数量不能小于1");
            return;
          }
          if (!this.form.businessEmail || this.form.businessEmail.trim() === "") {
            this.$message.error("回件商家邮箱不能为空");
            return;
          }
          if (!this.form.totalPrice || Number(this.form.totalPrice) <= 0) {
            this.$message.error("商品总价不能小于0");
            return;
          }

          if (this.form.collectionType !== 1 && this.form.collectionType !== 2) {
            this.$message.error("收款方式错误");
            return;
          }

          // 二维码验证
          if (this.form.collectionType === 1) {
            if (!this.form.collectionQrcode || this.form.collectionQrcode.trim() === "") {
              this.$message.error("收款码不能为空");
              return;
            }
          }
          // 银行卡验证
          else {
            if (!this.form.beneficiaryName || this.form.beneficiaryName.trim() === "") {
              this.$message.error("受益人姓名不能为空");
              return;
            }
            if (!this.form.beneficiaryAddress || this.form.beneficiaryAddress.trim() === "") {
              this.$message.error("受益人地址不能为空");
              return;
            }
            if (!this.form.beneficiaryAccNo || this.form.beneficiaryAccNo.trim() === "") {
              this.$message.error("受益人账号不能为空");
              return;
            }
            if (!this.form.addressOfBank || this.form.addressOfBank.trim() === "") {
              this.$message.error("银行地址不能为空");
              return;
            }
            if (!this.form.swiftCode || this.form.swiftCode.trim() === "") {
              this.$message.error("SWIFT码不能为空");
              return;
            }
            if (!this.form.postCode || this.form.postCode.trim() === "") {
              this.$message.error("邮政编码不能为空");
              return;
            }
            if (!this.form.beneficiaryBank || this.form.beneficiaryBank.trim() === "") {
              this.$message.error("受益人银行不能为空");
              return;
            }
          }
        }
        // 处理收款码URL，提交时去掉baseUrl
        const submitData = {
          ...this.form,
          collectionQrcode: this.form.collectionQrcode.replace(this.$baseUrl, ''),
          collectionType: this.form.collectionType
        };

        // 如果选择的是银行卡方式，不需要提交收款码
        if (this.form.collectionType === 2) {
          delete submitData.collectionQrcode;
        }

        this.$emit('confirm', submitData);
        this.closeDialog();
      },
      //判断图片大小
      handleBeforeUpload(file) {
        // 检查文件类型是否为图片
        const isImage = file.type.startsWith('image/');
        if (!isImage) {
          this.$message.error('只能上传图片类型的文件！');
          return false;
        }
        if (this.$maxImgSize) {
          //转化为kb
          const isLt = file.size / 1024 < this.$maxImgSize;
          if (!isLt) {
            this.$message.error(`上传的图片最大不能超过 ${this.$maxImgSize} KB!`);
            return false;
          }
        }
      },
      handelSuccess(response) {
        if (response.code == 200) {
          // 显示时拼接baseUrl，存储完整URL
          this.form.collectionQrcode = this.$baseUrl + response.data.relativeUrl;
          this.fileList = [{
            name: '收款码',
            url: this.form.collectionQrcode
          }];
          this.$message({
            message: "上传成功",
            type: "success",
          });
        } else if (response.code == 401) {
          this.$message({ message: response.msg, type: "error" });
          this.$router.push("/login");
        } else {
          this.$message({ message: response.msg, type: "error" });
        }
      },
      handleRemove() {
        this.form.collectionQrcode = "";
        this.fileList = [];
      },
      hadleExceed(files, fileList) {
        this.$message({
          message: "最多只能上传一张图片",
          type: "error",
        });
      },
      handlePictureCardPreview(file) {
        window.open(file.url, '_blank');
      }
    },
    created() {
      // 初始化表单数据
      this.form = {
        ...this.form,
        commodityName: this.product.commodityName,
        specifications: this.product.specifications,
        unitPrice: this.product.presentPrice,
        quantity: this.product.quantity,
        toUser: this.product.email,
        collectionType: this.product.collectionType || 1 // 使用product中的值或默认1
      };
      this.calculateTotalPrice();

      // 初始化收款码信息
      if (this.product.collectionQrcode) {
        this.form.collectionQrcode = this.$baseUrl + this.product.collectionQrcode;
        this.fileList = [{
          name: '收款码',
          url: this.form.collectionQrcode
        }];
      }
    }
  }
</script>

<style scoped>
  .audit-dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    padding: 16px;
  }

  .dialog-content {
    background-color: white;
    border-radius: 12px;
    width: 100%;
    max-width: 500px;
    max-height: 90vh;
    overflow-y: auto;
    padding: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }

  .section-title {
    font-size: 18px;
    margin: 16px 0 12px;
    color: #333;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
  }

  .product-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  .product-image {
    width: 80px;
    height: 80px;
    border-radius: 8px;
    object-fit: cover;
    margin-right: 12px;
  }

  .product-info {
    flex: 1;
  }

  .product-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .product-category {
    font-size: 14px;
    color: #666;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .detail-row {
    display: flex;
    margin-bottom: 8px;
    font-size: 14px;
    flex-wrap: wrap;
  }

  .label {
    color: #666;
    min-width: 80px;
    display: inline-block;
  }

  .price-label {
    margin-left: 16px;
  }

  .remark {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #666;
  }

  .form-group {
    margin-bottom: 12px;
  }

  .form-group label {
    display: block;
    margin-bottom: 4px;
    font-size: 14px;
    color: #666;
  }

  .form-input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 14px;
  }

  .payment-methods {
    display: flex;
    margin-bottom: 16px;
    border-bottom: 1px solid #eee;
  }

  .method-btn {
    flex: 1;
    padding: 10px;
    border: none;
    background: none;
    font-size: 14px;
    color: #666;
    border-bottom: 2px solid transparent;
    cursor: pointer;
  }

  .method-btn.active {
    color: #13af87;
    border-bottom-color: #13af87;
    font-weight: bold;
  }

  .upload-area {
    display: flex;
    gap: 10px;
    margin-bottom: 16px;
  }

  .upload-btn {
    flex: 1;
    height: 100px;
    border: 1px dashed #ccc;
    border-radius: 8px;
    background-color: #f9f9f9;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #666;
    cursor: pointer;
  }

  .action-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }

  .cancel-btn,
  .confirm-btn {
    flex: 1;
    padding: 12px;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
  }

  .cancel-btn {
    background-color: #f5f5f5;
    color: #666;
    margin-right: 12px;
  }

  .confirm-btn {
    background-color: #13af87;
    color: white;
  }

  /* 移动端优化 */
  @media (max-width: 480px) {
    .dialog-content {
      padding: 16px;
    }

    .product-image {
      width: 60px;
      height: 60px;
    }

    .section-title {
      font-size: 16px;
    }

    .form-input {
      padding: 8px;
    }

    .upload-btn {
      height: 80px;
    }

    .cancel-btn,
    .confirm-btn {
      padding: 10px;
      font-size: 14px;
    }

    .upload-area {
      justify-content: center;
    }

    .hide-upload>>>.el-upload--picture-card {
      display: none;
    }
  }
</style>